import {useEffect} from "react";
import {useQuery} from "@tanstack/react-query";

import {setStorageItem} from "@/lib/utils";
import useHasPermission from "@/src/hooks/useHasPermission";

import {dispatchLogsService} from "../services";

export default function useDispatchLogTypes() {
  const hasPermission = useHasPermission("dispatchlog store");

  const {data, isSuccess, isPending, isError} = useQuery({
    queryKey: ["dispatchLogTypes", hasPermission],
    queryFn: () => dispatchLogsService.getDispatchLogTypes(),
    enabled: hasPermission,
    retry: false,
    staleTime: Infinity,
    refetchInterval: false,
  });

  useEffect(() => {
    if (isSuccess && data) {
      setStorageItem("dispatchLogTypes", data);
    }
  }, [isSuccess, data]);

  return {
    dispatchLogTypes: hasPermission && isSuccess && data ? data : [],
    isPending: hasPermission && isPending,
    isError,
    isSuccess: hasPermission ? isSuccess : true,
  };
}
